import { NamedResourceCRUDPage } from "../components/named_resource_crud";
import { strategiesAdapter } from "../components/strategies/strategiesAdapter";

export function StrategiesPage() {
  return <NamedResourceCRUDPage adapter={strategiesAdapter} />;
}
